import { Component, OnInit } from '@angular/core';
import { Template } from '../_types/template';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { TemplatesService } from '../_services/templates.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { TabViewChangeEvent } from 'primeng/tabview';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-templates-list',
    templateUrl: './templates-list.component.html',
    styleUrls: ['./templates-list.component.scss'],
    standalone: false
})
export class TemplatesListComponent implements OnInit {
  public templatesDocuments: Template[] = [];
  public totalRecordsDocuments: number = 0;

  public templatesSMS: Template[] = [];
  public totalRecordsSMS: number = 0;
  public templatesCaseLogs: Template[] = [];
  public totalRecordsCaseLogs: number = 0;
  public templatesWhatsapp: Template[] = [];
  public totalRecordsWhatsapp: number = 0;
  public templatesEmail: Template[] = [];
  public totalRecordsEmail: number = 0;

  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
    templateType: new Filter(FilterOperation.equals, 'templateType')
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public templatesTypes: any = [];
  public templateDestinationTypes: any = [{value: 'Case', label: 'Expediente'}, {value: 'Worker', label: 'Operario'}, {value: null, label: 'Todos'}];
  constructor(
    public templatesService: TemplatesService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loginService: LoginService
  ) {
    
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Plantillas");
    this.topbarService.addAction("Nueva", "pi pi-plus", false, () => {
      this.edit({} as Template);
    });
    this.allowWrite = this.loginService.hasPermission("TEMPLATES.WRITE");
    this.allowDelete = this.loginService.hasPermission("TEMPLATES.DELETE");
    this.templatesTypes = this.templatesService.templateTypes();
  }

  public async loadDataDocument($event: any) {
  
    this.lastGridEvent = $event;
    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows },
    }
    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];
    this.filters.templateType.value ="Document"; 
    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();  

    let response = await firstValueFrom(this.templatesService.all(params));
    this.templatesDocuments = response.data;
    this.totalRecordsDocuments = response.meta['total'];
  }

  public async loadDataSMS($event: any) {
    
    this.lastGridEvent = $event;
    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }
    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];
    this.filters.templateType.value ="SMS";
    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();  

    let response = await firstValueFrom(this.templatesService.all(params));
    this.templatesSMS = response.data;
    this.totalRecordsSMS = response.meta['total'];
  }

  public async loadDataCaseLogs($event: any) {
    
    this.lastGridEvent = $event;
    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }
    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];
    this.filters.templateType.value ="CaseLog";
    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();  

    let response = await firstValueFrom(this.templatesService.all(params));
    this.templatesCaseLogs = response.data;
    this.totalRecordsCaseLogs = response.meta['total'];
  }

  public async loadDataWhatsapp($event: any) {
    
    this.lastGridEvent = $event;
    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }
    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];
    this.filters.templateType.value ="Whatsapp";
    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();  

    let response = await firstValueFrom(this.templatesService.all(params));
    this.templatesWhatsapp = response.data;
    this.totalRecordsWhatsapp = response.meta['total'];
  }

  public async loadDataEmail($event: any) {
    this.lastGridEvent = $event;
    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }
    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];
    this.filters.templateType.value ="Email";
    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();  

    let response = await firstValueFrom(this.templatesService.all(params));
    this.templatesEmail = response.data;
    this.totalRecordsEmail = response.meta['total'];
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadDataDocument(this.lastGridEvent);
  }


  edit(template: Template) {
    this.router.navigate(['templates/' + (template && Object.keys(template).length > 0 ? template.id : 0)]);
  }

  delete(template: Template) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la plantilla?",
        header: "Eliminar plantilla",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.templatesService.delete(template.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Plantilla eliminada correctamente" });
              this.loadDataDocument(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }

  async onTabChange(event: TabViewChangeEvent) {
    if (event.index == 0) {
      //bank accounts
      this.loadDataDocument(this.lastGridEvent);
    } else if (event.index == 1) {
      //capabilites
      this.loadDataEmail(this.lastGridEvent);
    } else if (event.index == 2) {
      //zones
      this.loadDataSMS(this.lastGridEvent);
    } else if (event.index == 3) {
      //case logs
      this.loadDataCaseLogs(this.lastGridEvent);
    }
  }

  getTemplateDestinationLabel(value: string | null): string {
  const match = this.templateDestinationTypes.find((opt:any) => opt.value === value);
  return match ? match.label : '';
}
}
